import styled from 'styled-components';
import { helpScoutArticle } from 'src/utils/helpScoutBeacon';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import i18n from 'src/utils/translate';
import { titleSmall } from 'styles-js/mixins/typography';
import Button from 'src/components/buttons/button';

type Props = {
  options: {
    value: string;
    text: string;
  }[];
  selected: string;
  onFilterClick: (value: string) => void;
}
export default function PostFilterInline({
  options,
  selected,
  onFilterClick,
}: Props): JSX.Element {

  const handleMoreInfoClick = () => {
    helpScoutArticle('209-what-is-similar-to-me');
    trackFootfallEvent(Event.Clicked, {
      clickType: 'similar-to-me-info',
      clickMetadata: { section: Section.CommunityMembers, element: Element.QuestionMark },
    });
  };

  return (
    <>
      {options.map(({ value, text }) => (
        <Container key={value}>
          <RoundedButton
            data-testid={selected === value ? 'selected' : ''}
            selected={selected === value}
            onClick={() => onFilterClick(value)}
          >
            {i18n.t(text)}
          </RoundedButton>
          {value === 'similar-to-me' && (
            <MoreInfoButton icon="information" type="link" onClick={handleMoreInfoClick}>
              <MoreInfoText>{i18n.t('What is this?')}</MoreInfoText>
            </MoreInfoButton>
          )}
        </Container>
      ))}
    </>
  );
}

const Container = styled.span`
  display: inline-block;
`;

const RoundedButton = styled.button<{ selected: boolean }>`
  ${titleSmall};
  line-height: ${props => props.theme.fontLineHeightSWide};
  padding: 2px 15px;
  margin: 0 9px 10px 0;
  border-color: transparent;
  border-radius: 20px;
  cursor: pointer;
  background-color: ${props => props.selected ? props.theme.colorBlue : props.theme.colorBlueBackground};
  color: ${props => props.selected ? props.theme.colorWhite : props.theme.colorBlack};

  &:hover, &:focus {
    background-color: ${props => props.theme.colorBlue};
    color: ${props => props.theme.colorWhite};
  }

  @media (${props => props.theme.underScreenXxsmall}) {
    padding: 1px 8px 2px 8px;
  }
`;

const MoreInfoButton = styled(Button)`
  padding-bottom: 6px;
  margin: 0;

  .icon {
    font-size: 24px;

    &:before {
      -webkit-font-smoothing: auto;
      -moz-osx-font-smoothing: auto;
      margin-right: 4px;
      vertical-align: middle;
    }
  }
`;

const MoreInfoText = styled.span`
  @media (${props => props.theme.underScreenXsmall}) {
    display: none;
  }
`;
